const esLang = {
  title: 'En construcción',
  desc: 'Estamos trabajando para una mejor experiencia',
  btn: 'Regresar a Home',
}
const enLang = {
  title: 'En construcción',
  desc: 'Estamos trabajando para una mejor experiencia',
  btn: 'Regresar a Home',
}

export const langTexts = {
  es: esLang,
  en: enLang
}